import { load } from './loader';
import * as gototopButton from './modules/gototopButton';

load([
  gototopButton
]);
